export default __webpack_public_path__ + "static/media/node.888b6bd0.png";